import { addressClient } from "@core/clients";
import { Address, User } from "@core/types";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { queryClient } from "../../config/query-client";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

type Props = {
  address: Address;
  customerId: User["id"] | undefined;
};

type Options = UseMutationOptions<Address | null, unknown, Props, string[]>;

const useUpdateCustomerAddress = (options?: Options) => {
  const { t } = useTranslation();
  return useMutation(
    ["customer-address", "update"],
    async ({ address, customerId }) => {
      return addressClient.updateCustomerAddress(address, customerId);
    },
    {
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries(["customer-address", "get"]);
        options?.onSuccess?.(data, variables, context);
      },
      onError: (error: any) => {
        if (error?.message?.includes("unique_customer_address")) {
          toast.error(t("This address already exist"));
        } else {
          console.log("error", error?.message);
        }
      },
      ...options,
    }
  );
};

export default useUpdateCustomerAddress;
